module.exports = __webpack_public_path__ + "images/accents/accent-sound-wave@1x-abde5273d382070546448da3b250d260.webp";